import { render } from "./index.vue?vue&type=template&id=4494bc68"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/app-review-settings/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4494bc68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4494bc68', __exports__)) {
    api.reload('4494bc68', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4494bc68", () => {
    api.rerender('4494bc68', render)
  })

}


export default __exports__